module.exports = __webpack_public_path__ + "static/media/view-amendment-appendix.60acc12d.svg";